import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import createHttp from 'utils/http';
import { login } from 'states/profile/actions';

import { BlockLoadGroup } from 'widgets-v5/load-group';

import CenterLayout from 'widgets-v5/center-layout';
import { PrimaryButton, ButtonGroup } from 'widgets-v5/buttons';
import Card from 'widgets-v5/card';

const http = createHttp({ redirectOnFail: false });

const EmailLoginEntry = props => {
    const [error, setError] = useState(null);
    useEffect(() => {
        const emailLoginToken = props.location.query.token;

        if (props.profile?.isLoggedIn || !emailLoginToken) {
            browserHistory.push('/');
            return;
        }

        http.post('auth?populate=user,role,organization', { emailLoginToken }).then(
            data => {
                props.dispatch(login(data));
                browserHistory.push('/');
            },
            err => {
                const code = _.get(err, `code`, void 0);
                if (code >= 400 && code <= 499) {
                    setError(
                        'The sign-in link you used has expired or has already been used. Please request a new link.'
                    );
                } else if ((code >= 500 && code <= 599) || code === void 0) {
                    setError('Server error, please try again later');
                }
            }
        );
    }, []);

    return (
        <CenterLayout className="ef5-reset-password">
            <BlockLoadGroup isLoading={!error} size="large">
                <div>
                    <img className="ef5-reset-password__logo" src="/images/EngageFront-logo.png" />
                    <Card
                        className="ef5-reset-password__card"
                        title={error ? 'Sign-in Error' : 'Sign-in'}
                        footer={
                            <ButtonGroup>
                                <PrimaryButton
                                    text="Sign In Again"
                                    onClick={() => browserHistory.push('/')}
                                />
                            </ButtonGroup>
                        }
                    >
                        <p style={{ lineHeight: '16px' }}>{error}</p>
                    </Card>
                </div>
            </BlockLoadGroup>
        </CenterLayout>
    );
};

function select(state) {
    const profile = _.get(state, 'profile', {});
    return { profile };
}

export default connect(select)(EmailLoginEntry);
